const AdminLogo = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 106 24"
    width="106"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6740_1472)">
      <path
        d="M5.71568 19.3659C5.70719 19.3768 5.70355 19.3816 5.69385 19.3998C5.57139 19.612 5.72295 19.9127 5.96666 19.9394C5.98606 19.9418 6.00061 19.9418 6.02729 19.9418L15.3489 19.9357C15.3756 19.9357 15.3901 19.9357 15.4095 19.9333C15.6532 19.9066 15.8048 19.6059 15.6811 19.3938C15.6714 19.3768 15.6666 19.3707 15.6593 19.3598C14.5341 17.8369 12.7251 16.85 10.6857 16.8512C8.64626 16.8524 6.83844 17.8418 5.71568 19.3659Z"
        fill="#164356"
      />
      <path
        d="M0.397688 10.562C0.384351 10.5608 0.377076 10.5596 0.357676 10.5596C0.112753 10.5596 -0.071545 10.8409 0.0266666 11.0652C0.035154 11.0834 0.0412164 11.0955 0.0557663 11.1185L4.72264 19.1876C4.73597 19.2107 4.74325 19.2228 4.75537 19.2386C4.90087 19.4362 5.23673 19.4168 5.35919 19.2046C5.36889 19.1876 5.37132 19.1816 5.37738 19.1694C6.13276 17.4332 6.08305 15.3731 5.06213 13.6078C4.04122 11.8424 2.28068 10.7717 0.398901 10.5608L0.397688 10.562Z"
        fill="#164356"
      />
      <path
        d="M5.36404 1.55441C5.35919 1.54228 5.35555 1.53622 5.34585 1.51925C5.22339 1.30706 4.88753 1.28766 4.74203 1.4853C4.72991 1.50106 4.72385 1.51318 4.7093 1.53743L0.0557665 9.61261C0.0424291 9.63686 0.0351542 9.64777 0.0278792 9.66596C-0.0703323 9.89027 0.113966 10.1728 0.360101 10.1716C0.379501 10.1716 0.386776 10.1716 0.400113 10.1691C2.2819 9.95574 4.04 8.88269 5.05849 7.11609C6.07698 5.3495 6.12427 3.28948 5.36525 1.55441H5.36404Z"
        fill="#164356"
      />
      <path
        d="M15.6472 1.35071C15.6557 1.3398 15.6593 1.33495 15.669 1.31676C15.7915 1.10458 15.6399 0.80388 15.3962 0.777205C15.3768 0.77478 15.3622 0.77478 15.3356 0.77478L6.01395 0.780843C5.98727 0.780843 5.97272 0.780843 5.95332 0.783268C5.70961 0.809942 5.55805 1.11064 5.68173 1.32283C5.69143 1.3398 5.69628 1.34586 5.70355 1.35677C6.82874 2.87966 8.63777 3.86663 10.6772 3.8642C12.7166 3.86299 14.5244 2.8736 15.6472 1.3495V1.35071Z"
        fill="#164356"
      />
      <path
        d="M20.9676 10.1558C20.9809 10.157 20.9882 10.1582 21.0076 10.1582C21.2525 10.1582 21.4368 9.87694 21.3386 9.65263C21.3301 9.63444 21.324 9.62231 21.3107 9.59928L16.6426 1.52895C16.6293 1.5047 16.622 1.49379 16.6099 1.47803C16.4644 1.28039 16.1285 1.29979 16.006 1.51198C15.9963 1.52895 15.9939 1.53501 15.9879 1.54714C15.2325 3.28342 15.2822 5.34344 16.3031 7.10882C17.324 8.87421 19.0846 9.94483 20.9663 10.1558H20.9676Z"
        fill="#164356"
      />
      <path
        d="M15.9988 19.1634C16.0036 19.1755 16.0073 19.1816 16.017 19.1985C16.1394 19.4119 16.4753 19.4301 16.6208 19.2325C16.6329 19.2167 16.639 19.2046 16.6535 19.1804L21.3083 11.104C21.3216 11.0797 21.3289 11.0688 21.3362 11.0506C21.4344 10.8263 21.2501 10.5438 21.0039 10.545C20.9845 10.545 20.9773 10.545 20.9639 10.5474C19.0821 10.7608 17.324 11.8339 16.3056 13.6005C15.2871 15.3671 15.2398 17.4271 15.9988 19.1622V19.1634Z"
        fill="#164356"
      />
      <path
        d="M10.6772 15.4059C13.4695 15.4059 15.7332 13.1422 15.7332 10.3498C15.7332 7.55744 13.4695 5.29372 10.6772 5.29372C7.88481 5.29372 5.62109 7.55744 5.62109 10.3498C5.62109 13.1422 7.88481 15.4059 10.6772 15.4059Z"
        fill="#164356"
      />
      <path
        d="M100.5 5.45399C103.335 5.45399 105.441 7.53299 105.441 10.719V19.683H101.958V11.313C101.958 9.50399 100.932 8.47799 99.528 8.47799C97.881 8.47799 96.693 9.58499 96.693 11.502V19.683H93.21V5.77799H96.693V7.58699C97.53 6.07499 98.934 5.45399 100.5 5.45399Z"
        fill="#164356"
      />
      <path
        d="M88.7951 4.185C87.5531 4.185 86.5541 3.429 86.5541 2.106C86.5541 0.809999 87.5531 0 88.7951 0C90.0371 0 91.0361 0.809999 91.0361 2.106C91.0361 3.429 90.0371 4.185 88.7951 4.185ZM87.0401 19.683V5.778H90.5231V19.683H87.0401Z"
        fill="#164356"
      />
      <path
        d="M79.6683 5.45399C82.4223 5.45399 84.4743 7.45199 84.4743 10.503V19.683H80.9913V11.205C80.9913 9.44999 80.0733 8.47799 78.8313 8.47799C77.3463 8.47799 76.2663 9.50399 76.2663 11.313V19.683H72.7833V11.205C72.7833 9.44999 71.8653 8.47799 70.6233 8.47799C69.1383 8.47799 68.0583 9.50399 68.0583 11.313V19.683H64.5753V5.77799H68.0583V7.53299C68.8413 6.07499 70.1373 5.45399 71.6493 5.45399C73.3773 5.45399 74.8083 6.29099 75.6183 7.72199C76.4553 6.12899 77.9403 5.45399 79.6683 5.45399Z"
        fill="#164356"
      />
      <path
        d="M58.4015 7.83V0.782997H61.8845V19.683H58.4015V17.685C57.5375 19.035 56.1605 20.007 54.0815 20.007C50.5175 20.007 47.8445 16.902 47.8445 12.717C47.8445 8.559 50.5175 5.454 54.0815 5.454C56.1605 5.454 57.5375 6.453 58.4015 7.83ZM54.9455 16.902C57.0245 16.902 58.4555 15.39 58.4555 12.717C58.4555 10.044 57.0245 8.559 54.9455 8.559C52.8665 8.559 51.4085 10.044 51.4085 12.717C51.4085 15.39 52.8665 16.902 54.9455 16.902Z"
        fill="#164356"
      />
      <path
        d="M34.643 14.796L32.834 19.683H29L36.425 0.782997H40.016L47.468 19.683H43.526L41.717 14.796H34.643ZM35.75 11.772H40.61L38.18 5.184L35.75 11.772Z"
        fill="#164356"
      />
    </g>
    <defs>
      <clipPath id="clip0_6740_1472">
        <rect fill="white" height="24" width="106" />
      </clipPath>
    </defs>
  </svg>
);

export default AdminLogo;
